import React, { useEffect } from "react";
import CommandePage from "../components/CommandeSuivi/CommandePage";
import HomeHeader from "../components/homePage/HomeHeader";
import HomeHeader2 from "@/components/homePage/HomeHeader2";

function CommandeSuivi({ paniernbr, acces }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <CommandePage />
    </>
  );
}

export default CommandeSuivi;
